import { axiosInstance } from "./";

const login = async (payload) => await axiosInstance.post("/sessions", payload);

const logout = async (payload) =>
  await axiosInstance.delete("/sessions", { data: payload });

const changePassword = async (payload) =>
  await axiosInstance.post("/admins/change_password", payload);

const forgetPassword = async (payload) =>
  await axiosInstance.post("/admins/forget_password", payload);

export { login, logout, changePassword, forgetPassword };
